import type { AdImpression, AdPlacement } from '@accra/shared';
import { api } from './apiClient';

export async function fetchPlacements(route: string): Promise<AdPlacement[]> {
  const result = await api<{ placements: AdPlacement[] }>('GET', `/ads?route=${encodeURIComponent(route)}`, null);
  return result?.ok ? result.placements : [];
}

export async function reportImpressions(key: string | null, items: readonly AdImpression[]): Promise<void> {
  if (!key || items.length === 0) return;
  await api('POST', '/ads/impressions', key, { items: items.slice(0, 50) });
}
